"use strict";
/**
 * Every response the API produces has this shape, success or failure, so a
 * client has one parser rather than two. Carried over verbatim from AMBIT's
 * `common/response.interceptor.ts`, and the reason it lives in a shared package
 * here is that the SPA's axios interceptor unwraps on exactly this contract.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSuccess = isSuccess;
function isSuccess(envelope) {
    return envelope.status === 'success';
}
//# sourceMappingURL=envelope.js.map